import {MarketplaceThemesResponse, getMarketplaceThemes} from '@/api/marketplace';
import {useQuery} from '@tanstack/react-query';

export function useMarketplaceThemes() {
    return useQuery<MarketplaceThemesResponse, Error>({
        queryKey: ['marketplace_themes', 'public-catalog'],
        queryFn: getMarketplaceThemes
    });
}
